import { cn } from "@/client/lib/classnames";
import { motion } from "motion/react";

// Special icons for the nav menu that are pulled from the curated site
export const MenuIcon = (
  props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Menu">
      <path
        id="Vector"
        d="M14 8C14 8.13261 13.9473 8.25979 13.8536 8.35355C13.7598 8.44732 13.6326 8.5 13.5 8.5H2.5C2.36739 8.5 2.24021 8.44732 2.14645 8.35355C2.05268 8.25979 2 8.13261 2 8C2 7.86739 2.05268 7.74021 2.14645 7.64645C2.24021 7.55268 2.36739 7.5 2.5 7.5H13.5C13.6326 7.5 13.7598 7.55268 13.8536 7.64645C13.9473 7.74021 14 7.86739 14 8ZM2.5 4.5H13.5C13.6326 4.5 13.7598 4.44732 13.8536 4.35355C13.9473 4.25979 14 4.13261 14 4C14 3.86739 13.9473 3.74021 13.8536 3.64645C13.7598 3.55268 13.6326 3.5 13.5 3.5H2.5C2.36739 3.5 2.24021 3.55268 2.14645 3.64645C2.05268 3.74021 2 3.86739 2 4C2 4.13261 2.05268 4.25979 2.14645 4.35355C2.24021 4.44732 2.36739 4.5 2.5 4.5ZM13.5 11.5H2.5C2.36739 11.5 2.24021 11.5527 2.14645 11.6464C2.05268 11.7402 2 11.8674 2 12C2 12.1326 2.05268 12.2598 2.14645 12.3536C2.24021 12.4473 2.36739 12.5 2.5 12.5H13.5C13.6326 12.5 13.7598 12.4473 13.8536 12.3536C13.9473 12.2598 14 12.1326 14 12C14 11.8674 13.9473 11.7402 13.8536 11.6464C13.7598 11.5527 13.6326 11.5 13.5 11.5Z"
      />
    </g>
  </svg>
);

export const SearchIcon = (
  props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={props.fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Icon / Search">
      <path
        id="shape"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.87041 6.08067C3.6442 8.30688 3.6442 11.9163 5.87041 14.1425C8.09661 16.3687 11.706 16.3687 13.9322 14.1425C16.1584 11.9163 16.1584 8.30688 13.9322 6.08067C11.706 3.85446 8.09661 3.85446 5.87041 6.08067ZM4.71872 15.2942C1.85646 12.4319 1.85646 7.79125 4.71872 4.92898C7.58098 2.06672 12.2216 2.06672 15.0839 4.92898C17.7515 7.59661 17.9329 11.809 15.6281 14.6867L20.2495 19.3081C20.5676 19.6261 20.5676 20.1418 20.2495 20.4598C19.9315 20.7778 19.4159 20.7778 19.0979 20.4598L14.4764 15.8384C11.5987 18.1432 7.38634 17.9618 4.71872 15.2942Z"
        fill={props.fill}
      />
    </g>
  </svg>
);

export const UserCircleConnectedIcon = (
  props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M16 1C13.0333 1 10.1332 1.87973 7.66645 3.52796C5.19971 5.17618 3.27713 7.51886 2.14181 10.2597C1.0065 13.0006 0.709449 16.0166 1.28823 18.9264C1.86701 21.8361 3.29562 24.5088 5.3934 26.6066C7.49119 28.7044 10.1639 30.133 13.0736 30.7118C15.9834 31.2906 18.9994 30.9935 21.7403 29.8582C24.4811 28.7229 26.8238 26.8003 28.472 24.3335C30.1203 21.8668 31 18.9667 31 16C30.9958 12.023 29.4141 8.21017 26.602 5.39804C23.7898 2.5859 19.977 1.0042 16 1ZM25.4846 24.4245C24.1977 22.5597 22.3882 21.117 20.2837 20.2779C21.4142 19.3875 22.2391 18.1669 22.6437 16.7859C23.0484 15.4049 23.0126 13.9321 22.5415 12.5724C22.0703 11.2127 21.1871 10.0336 20.0147 9.19907C18.8423 8.36456 17.4391 7.91612 16 7.91612C14.561 7.91612 13.1577 8.36456 11.9853 9.19907C10.8129 10.0336 9.92972 11.2127 9.45854 12.5724C8.98736 13.9321 8.95161 15.4049 9.35626 16.7859C9.76091 18.1669 10.5858 19.3875 11.7164 20.2779C9.61176 21.117 7.80226 22.5597 6.51539 24.4245C4.88929 22.5959 3.82646 20.3362 3.45488 17.9175C3.0833 15.4989 3.41882 13.0244 4.42104 10.792C5.42326 8.55957 7.04944 6.66449 9.10376 5.33491C11.1581 4.00533 13.553 3.29795 16 3.29795C18.447 3.29795 20.8419 4.00533 22.8962 5.33491C24.9506 6.66449 26.5767 8.55957 27.579 10.792C28.5812 13.0244 28.9167 15.4989 28.5451 17.9175C28.1736 20.3362 27.1107 22.5959 25.4846 24.4245Z" />
  </svg>
);

export const UserIcon = (
  props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="User">
      <path
        id="Vector"
        d="M14.4324 13.25C13.4806 11.6044 12.0137 10.4244 10.3018 9.86499C11.1486 9.3609 11.8065 8.59279 12.1744 7.67861C12.5424 6.76444 12.6001 5.75474 12.3387 4.80459C12.0773 3.85444 11.5112 3.01636 10.7274 2.41907C9.94359 1.82178 8.98538 1.49829 7.99993 1.49829C7.01447 1.49829 6.05626 1.82178 5.27244 2.41907C4.48863 3.01636 3.92255 3.85444 3.66114 4.80459C3.39973 5.75474 3.45744 6.76444 3.82542 7.67861C4.19339 8.59279 4.85128 9.3609 5.69805 9.86499C3.98618 10.4237 2.5193 11.6037 1.56743 13.25C1.53252 13.3069 1.50936 13.3702 1.49933 13.4363C1.4893 13.5023 1.49259 13.5696 1.509 13.6343C1.52542 13.6991 1.55463 13.7598 1.59492 13.8131C1.63521 13.8663 1.68575 13.911 1.74357 13.9444C1.80138 13.9778 1.8653 13.9992 1.93156 14.0075C1.99781 14.0158 2.06505 14.0108 2.12931 13.9926C2.19358 13.9745 2.25356 13.9437 2.30573 13.902C2.3579 13.8604 2.40119 13.8087 2.43305 13.75C3.61055 11.715 5.6918 10.5 7.99993 10.5C10.3081 10.5 12.3893 11.715 13.5668 13.75C13.5987 13.8087 13.642 13.8604 13.6941 13.902C13.7463 13.9437 13.8063 13.9745 13.8705 13.9926C13.9348 14.0108 14.002 14.0158 14.0683 14.0075C14.1345 13.9992 14.1985 13.9778 14.2563 13.9444C14.3141 13.911 14.3646 13.8663 14.4049 13.8131C14.4452 13.7598 14.4744 13.6991 14.4908 13.6343C14.5073 13.5696 14.5106 13.5023 14.5005 13.4363C14.4905 13.3702 14.4673 13.3069 14.4324 13.25ZM4.49993 5.99999C4.49993 5.30776 4.7052 4.63107 5.08978 4.0555C5.47437 3.47992 6.02099 3.03132 6.66053 2.76641C7.30008 2.50151 8.00381 2.43219 8.68274 2.56724C9.36168 2.70229 9.98532 3.03563 10.4748 3.52512C10.9643 4.0146 11.2976 4.63824 11.4327 5.31718C11.5677 5.99611 11.4984 6.69984 11.2335 7.33938C10.9686 7.97892 10.52 8.52555 9.94442 8.91014C9.36885 9.29472 8.69216 9.49999 7.99993 9.49999C7.07197 9.499 6.18231 9.12993 5.52615 8.47377C4.86999 7.81761 4.50092 6.92794 4.49993 5.99999Z"
      />
    </g>
  </svg>
);

export const ArrowRightIcon = (
  props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="ArrowRight">
      <path
        id="Vector"
        d="M12.122 7.80953L8.18453 11.747C8.10244 11.8291 7.9911 11.8752 7.875 11.8752C7.7589 11.8752 7.64756 11.8291 7.56547 11.747C7.48338 11.6649 7.43726 11.5536 7.43726 11.4375C7.43726 11.3214 7.48338 11.2101 7.56547 11.128L10.7565 7.9375H2.1875C2.07147 7.9375 1.96019 7.89141 1.87814 7.80936C1.79609 7.72731 1.75 7.61603 1.75 7.5C1.75 7.38397 1.79609 7.27269 1.87814 7.19064C1.96019 7.10859 2.07147 7.0625 2.1875 7.0625H10.7565L7.56547 3.87203C7.48338 3.78994 7.43726 3.6786 7.43726 3.5625C7.43726 3.4464 7.48338 3.33506 7.56547 3.25297C7.64756 3.17088 7.7589 3.12476 7.875 3.12476C7.9911 3.12476 8.10244 3.17088 8.18453 3.25297L12.122 7.19047C12.1627 7.2311 12.195 7.27935 12.217 7.33246C12.239 7.38557 12.2503 7.4425 12.2503 7.5C12.2503 7.55749 12.239 7.61442 12.217 7.66754C12.195 7.72065 12.1627 7.7689 12.122 7.80953Z"
      />
    </g>
  </svg>
);

export const XIcon = (
  props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path d="M12.8538 12.1463C12.9002 12.1927 12.9371 12.2479 12.9622 12.3086C12.9874 12.3693 13.0003 12.4343 13.0003 12.5C13.0003 12.5657 12.9874 12.6308 12.9622 12.6915C12.9371 12.7522 12.9002 12.8073 12.8538 12.8538C12.8073 12.9002 12.7522 12.9371 12.6915 12.9622C12.6308 12.9874 12.5657 13.0003 12.5 13.0003C12.4343 13.0003 12.3693 12.9874 12.3086 12.9622C12.2479 12.9371 12.1927 12.9002 12.1463 12.8538L8.00003 8.70691L3.85378 12.8538C3.75996 12.9476 3.63272 13.0003 3.50003 13.0003C3.36735 13.0003 3.2401 12.9476 3.14628 12.8538C3.05246 12.76 2.99976 12.6327 2.99976 12.5C2.99976 12.3674 3.05246 12.2401 3.14628 12.1463L7.29316 8.00003L3.14628 3.85378C3.05246 3.75996 2.99976 3.63272 2.99976 3.50003C2.99976 3.36735 3.05246 3.2401 3.14628 3.14628C3.2401 3.05246 3.36735 2.99976 3.50003 2.99976C3.63272 2.99976 3.75996 3.05246 3.85378 3.14628L8.00003 7.29316L12.1463 3.14628C12.2401 3.05246 12.3674 2.99976 12.5 2.99976C12.6327 2.99976 12.76 3.05246 12.8538 3.14628C12.9476 3.2401 13.0003 3.36735 13.0003 3.50003C13.0003 3.63272 12.9476 3.75996 12.8538 3.85378L8.70691 8.00003L12.8538 12.1463Z" />
  </svg>
);

export const DiscordLogoIcon = (
  props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M13.5535 3.03077C12.5178 2.54923 11.4104 2.19927 10.2526 2C10.1104 2.25546 9.94429 2.59905 9.82976 2.87238C8.599 2.68846 7.37956 2.68846 6.17144 2.87238C6.05693 2.59905 5.88704 2.25546 5.74357 2C4.58454 2.19927 3.47584 2.55052 2.44013 3.03332C0.351095 6.17027 -0.215207 9.22931 0.0679444 12.2449C1.4535 13.2731 2.79627 13.8977 4.11638 14.3064C4.44233 13.8607 4.73302 13.3868 4.98345 12.8874C4.5065 12.7073 4.04969 12.4851 3.61805 12.227C3.73256 12.1427 3.84457 12.0546 3.95279 11.9639C6.58546 13.1875 9.44593 13.1875 12.0472 11.9639C12.1566 12.0546 12.2686 12.1427 12.3819 12.227C11.949 12.4863 11.4909 12.7086 11.014 12.8887C11.2644 13.3868 11.5538 13.8619 11.881 14.3077C13.2024 13.899 14.5464 13.2744 15.932 12.2449C16.2642 8.74906 15.3644 5.71812 13.5535 3.03077ZM5.34212 10.3903C4.55181 10.3903 3.9037 9.65719 3.9037 8.76439C3.9037 7.87158 4.53797 7.13716 5.34212 7.13716C6.14628 7.13716 6.79437 7.8703 6.78053 8.76439C6.78178 9.65719 6.14628 10.3903 5.34212 10.3903ZM10.6578 10.3903C9.86752 10.3903 9.21941 9.65719 9.21941 8.76439C9.21941 7.87158 9.85366 7.13716 10.6578 7.13716C11.462 7.13716 12.1101 7.8703 12.0962 8.76439C12.0962 9.65719 11.462 10.3903 10.6578 10.3903Z" />
  </svg>
);

export const XLogoIcon = (
  props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_173_547)">
      <path d="M13.5222 10.6946L19.4785 3.5H18.0671L12.8952 9.74701L8.76437 3.5H4L10.2466 12.9466L4 20.4913H5.41155L10.8732 13.8942L15.2356 20.4913H20L13.5218 10.6946H13.5222ZM11.5889 13.0298L10.956 12.0891L5.92015 4.60416H8.0882L12.1522 10.6448L12.7851 11.5854L18.0677 19.4373H15.8997L11.5889 13.0302V13.0298Z" />
    </g>
    <defs>
      <clipPath id="clip0_173_547">
        <rect width="16" height="17" transform="translate(4 3.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const FarcasterLogoIcon = (
  props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M4.12451 2.48901H11.8756V13.5112H10.7378V8.46234H10.7267C10.6009 7.06695 9.42819 5.97345 8.00006 5.97345C6.57194 5.97345 5.3992 7.06695 5.27344 8.46234H5.26229V13.5112H4.12451V2.48901Z" />
    <path d="M2.06201 4.05322L2.52424 5.61767H2.91534V11.9466C2.71897 11.9466 2.55979 12.1058 2.55979 12.3021V12.7288H2.48868C2.29232 12.7288 2.13312 12.888 2.13312 13.0843V13.511H6.11534V13.0843C6.11534 12.888 5.95616 12.7288 5.75979 12.7288H5.68868V12.3021C5.68868 12.1058 5.52948 11.9466 5.33312 11.9466H4.90646V4.05322H2.06201Z" />
    <path d="M10.8091 11.9466C10.6127 11.9466 10.4535 12.1058 10.4535 12.3021V12.7288H10.3824C10.186 12.7288 10.0269 12.888 10.0269 13.0843V13.511H14.0091V13.0843C14.0091 12.888 13.8499 12.7288 13.6535 12.7288H13.5824V12.3021C13.5824 12.1058 13.4232 11.9466 13.2269 11.9466V5.61767H13.618L14.0802 4.05322H11.2357V11.9466H10.8091Z" />
  </svg>
);

export const YoutubeLogoIcon = (
  props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M13.0767 2.12275C10.674 1.95875 5.32267 1.95942 2.92333 2.12275C0.325333 2.30008 0.0193333 3.86942 0 8.00008C0.0193333 12.1234 0.322667 13.6994 2.92333 13.8774C5.32333 14.0408 10.674 14.0414 13.0767 13.8774C15.6747 13.7001 15.9807 12.1308 16 8.00008C15.9807 3.87675 15.6773 2.30075 13.0767 2.12275ZM6 10.6667V5.33342L11.3333 7.99542L6 10.6667Z" />
  </svg>
);

export const InstagramLogoIcon = (
  props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 3.0815C9.602 3.0815 9.792 3.0875 10.425 3.1165C12.051 3.1905 12.8105 3.962 12.8845 5.576C12.9135 6.2085 12.919 6.3985 12.919 8.0005C12.919 9.603 12.913 9.7925 12.8845 10.425C12.81 12.0375 12.0525 12.8105 10.425 12.8845C9.792 12.9135 9.603 12.9195 8 12.9195C6.398 12.9195 6.208 12.9135 5.5755 12.8845C3.9455 12.81 3.19 12.035 3.116 10.4245C3.087 9.792 3.081 9.6025 3.081 8C3.081 6.398 3.0875 6.2085 3.116 5.5755C3.1905 3.962 3.948 3.19 5.5755 3.116C6.2085 3.0875 6.398 3.0815 8 3.0815ZM8 2C6.3705 2 6.1665 2.007 5.5265 2.036C3.3475 2.136 2.1365 3.345 2.0365 5.526C2.007 6.1665 2 6.3705 2 8C2 9.6295 2.007 9.834 2.036 10.474C2.136 12.653 3.345 13.864 5.526 13.964C6.1665 13.993 6.3705 14 8 14C9.6295 14 9.834 13.993 10.474 13.964C12.651 13.864 13.865 12.655 13.9635 10.474C13.993 9.834 14 9.6295 14 8C14 6.3705 13.993 6.1665 13.964 5.5265C13.866 3.3495 12.6555 2.1365 10.4745 2.0365C9.834 2.007 9.6295 2 8 2V2ZM8 4.919C6.2985 4.919 4.919 6.2985 4.919 8C4.919 9.7015 6.2985 11.0815 8 11.0815C9.7015 11.0815 11.081 9.702 11.081 8C11.081 6.2985 9.7015 4.919 8 4.919ZM8 10C6.8955 10 6 9.105 6 8C6 6.8955 6.8955 6 8 6C9.1045 6 10 6.8955 10 8C10 9.105 9.1045 10 8 10ZM11.203 4.0775C10.805 4.0775 10.4825 4.4 10.4825 4.7975C10.4825 5.195 10.805 5.5175 11.203 5.5175C11.6005 5.5175 11.9225 5.195 11.9225 4.7975C11.9225 4.4 11.6005 4.0775 11.203 4.0775Z" />
  </svg>
);

export function LoadingIndicator({
  className,
}: {
  className?: string;
}): React.ReactElement {
  return (
    <motion.svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("origin-center", className)}
      animate={{
        rotate: 360,
        transition: { duration: 1.5, repeat: Infinity, ease: "linear" },
      }}
    >
      <g>
        <circle cx="3" cy="12" r="2" />
        <circle cx="21" cy="12" r="2" />
        <circle cx="12" cy="21" r="2" />
        <circle cx="12" cy="3" r="2" />
        <circle cx="5.64" cy="5.64" r="2" />
        <circle cx="18.36" cy="18.36" r="2" />
        <circle cx="5.64" cy="18.36" r="2" />
        <circle cx="18.36" cy="5.64" r="2" />
      </g>
    </motion.svg>
  );
}
